import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthorizationService } from '../service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  loadPermissions,
  loadPermissionsFailure,
  loadPermissionsSuccess
} from './authorization.actions';

@Injectable()
export class AuthorizationEffects {
  constructor(private actions$: Actions, private authorizationService: AuthorizationService) {}

  handleLoadPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPermissions),
      mergeMap(() =>
        this.authorizationService.loadPermissions().pipe(
          map((response) => loadPermissionsSuccess({ permissions: response })),
          catchError((error) => of(loadPermissionsFailure({ error })))
        )
      )
    )
  );
}
